import Image from 'app/Components/Shared/Image/image';
import React from 'react';

const IconTitlePair = ({titleIcon, title}) => {
  return (
    <div className='icon-title-pair-container'>
      {titleIcon && <Image className='title-icon' src={titleIcon} />}
      {title && <span className='title-text'>{title}</span>}
    </div>
  );
}

export default IconTitlePair;
